import App from 'app/app.js';

function ShippingTypeService() {
  this.allPackagesDigital = function (subject) {
    return (
      subject?.packages?.length > 0 &&
      subject.packages.every((pkg) => pkg.orderable?.items?.every((item) => item.digitalDelivery === true))
    );
  };

  this.allAddOnsDigital = function (subject) {
    return subject?.addOns?.length > 0 && subject.addOns.every((addOn) => addOn.orderable?.digitalDelivery === true);
  };

  this.getDeliveryType = function (subject) {
    const packages = subject?.packages ?? [];
    const addOns = subject?.addOns ?? [];
    const bundles = subject?.bundles ?? [];
    const shipToHome = subject?.jobContext?.shipToHome === true;

    if (packages.length === 0 && addOns.length === 0 && bundles.length === 0) {
      return false;
    }

    const hasPhysicalPackage = packages.some((pkg) =>
      pkg.orderable?.items?.some((item) => item.digitalDelivery !== true)
    );
    const hasPhysicalAddOn = addOns.some((addOn) => addOn.orderable?.digitalDelivery !== true);

    const hasPhysicalBundle = bundles.some((bundle) =>
      bundle.orderable?.items?.some((item) => item.digitalDelivery !== true)
    );

    const hasPhysicalCyop = packages.some(
      (pkg) =>
        pkg.orderable?.substitutable === true &&
        pkg.orderLineDetails?.some((detail) => detail?.item?.digitalDelivery !== true)
    );

    if (hasPhysicalPackage || hasPhysicalAddOn || hasPhysicalCyop || hasPhysicalBundle) {
      return shipToHome ? 'SHIPS_TO_HOME' : 'SHIPS_TO_SCHOOL';
    } else {
      return 'DIGITAL';
    }
  };
}

App.service('ShippingTypeService', [ShippingTypeService]);
